module.exports = __webpack_public_path__ + "img/Loeland_Rasmus_Loeland.8f7b8524.jpg";